import { StepContentReferenceType } from "@sdbn/appclient";

export const TERMINAL_WIZARD_DEFINITION = {
  identifier: 'registration-terminal-wizard-configuration',
  defaultWizardFlowStepIdentifier: 'registration-terminal-transport-registration',
  wizardFlowMetadata: [
    {
      flowIdentifier: 'registration-terminal-transport-registration',
      flowDefinition: {
        title: 'Transport Anmelden',
        key: 'registration-terminal-transport-registration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.language-selection.title',
            key: 'language-selection',
            controller: 'language-selection-controller',
            contentIdentifier: 'dashboard-language-selection'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'registration-type-selection',
            controller: 'process-selection-controller',
            contentIdentifier: 'processSelectionWidget',
            stepContentReferenceType: StepContentReferenceType.simpleDashboard,
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.primary',
                  titleIconCss: 'fa-thin fa-barcode',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.primary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'transport-registration-with-code'
                },
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.secondary',
                  titleIconCss: 'fa-thin fa-plus',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.secondary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'vehicle-type-selection'
                }
              ]
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.title',
            key: 'transport-registration-with-code',
            controller: 'transport-registration-with-code-controller',
            contentIdentifier: 'dashboard-transport-registration-with-code',
            dashboardConfiguration: {
              nextProcessStepQrCodeScanned: 'transport-registration-masterdata',
              nextProcessStepRegistrationCode: 'transport-registration-masterdata'
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'vehicle-type-selection',
            controller: 'dictionary-lookup-selection-controller',
            contentIdentifier: 'tileSelectionWidget',
            stepContentReferenceType: StepContentReferenceType.simpleDashboard,
            dashboardConfiguration: {
              dictionaryKey: 'tmc-yard.common.enum.vehicle-type',
              targetField: 'vehicleType',
              restrictOptions: ['truck','light-van']
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-masterdata.title',
            key: 'transport-registration-masterdata',
            controller: 'transport-registration-masterdata-controller',
            contentIdentifier: 'dashboard-transport-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-options.title',
            key: 'transport-registration-options',
            controller: 'transport-registration-options-controller',
            contentIdentifier: 'dashboard-transport-registration-options'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.title',
            key: 'transport-registration-smartphone-connection',
            controller: 'transport-registration-smartphone-connection-controller',
            contentIdentifier: 'dashboard-transport-registration-smartphone-connection',
            dashboardConfiguration: {
              availableOptions: ['messaging-hint','global-connect', 'sms'],
              showPhoneNumberInputForGlobalConnect: false,
              hidePhoneNumberInput: false,
              showPhoneNumberDialog: true,
              showHints: false
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-instructions.title',
            key: 'instruction-test',
            controller: 'instruction-test-controller',
            contentIdentifier: 'WIDGET@instructionTestWidget',
            dashboardConfiguration: {
              instructionConfigurationUrls: ['/assets/customer/kardex/transport-instruction.json']
            }
          },
          {
            title: null,
            key: 'transport-registration-send-data-to-backend',
            controller: 'transport-registration-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-summary.title',
            key: 'transport-registration-summary',
            controller: 'transport-registration-summary-controller',
            contentIdentifier: 'dashboard-transport-registration-summary'
          }
        ]
      }
    },
    {
      flowIdentifier: 'registration-terminal-truck-registration',
      flowDefinition: {
        title: 'LKW Anmelden',
        key: 'registration-terminal-truck-registration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.truck-registration-masterdata.title',
            key: 'truck-registration-masterdata',
            controller: 'truck-registration-masterdata-controller',
            contentIdentifier: 'dashboard-truck-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.title',
            key: 'truck-registration-smartphone-connection',
            controller: 'truck-registration-smartphone-connection-controller',
            contentIdentifier: 'dashboard-transport-registration-smartphone-connection'
          },
          {
            title: null,
            key: 'truck-registration-send-data-to-backend',
            controller: 'truck-registration-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-summary.title',
            key: 'truck-registration-summary',
            controller: 'truck-registration-summary-controller',
            contentIdentifier: 'dashboard-truck-registration-summary'
          }
        ]
      }
    }
  ]
};
